import React from 'react';
import { CardBody, Table, Input, Card } from 'reactstrap';
import { formatDecimal } from '../../../utils/numberUtils';

const TotalsSummary = ({ formik, calculateSubtotal, calculateDiscount, calculateTotal, taxesBreakdown }: any) => {
    
    const safeCalculateTotal = () => {
        const total = calculateTotal();
        return isNaN(total) ? 0 : total;
    };

    return (
        <Card className="shadow border-0 overflow-hidden rounded-3 mb-4">
            <div className="bg-soft-primary p-3 border-bottom border-light">
                <h5 className="card-title mb-0 text-primary fw-semibold d-flex align-items-center">
                    <i className="ri-calculator-fill me-2 fs-18"></i>
                    Resumen de Valores
                </h5>
            </div>
            <CardBody className="p-4 bg-white">
                <div className="table-responsive">
                    <Table className="table-sm table-borderless mb-0">
                        <tbody>
                            <tr>
                                <td className="text-muted">Subtotal sin impuestos:</td>
                                <td className="text-end fw-medium">{formatDecimal(calculateSubtotal())}</td>
                            </tr>
                            <tr>
                                <td className="text-muted">Descuento:</td>
                                <td className="text-end fw-medium text-danger">-{formatDecimal(calculateDiscount())}</td>
                            </tr>
                            
                            {/* Desglose de Impuestos Dinámico */}
                            {taxesBreakdown.map((tax: any, index: number) => (
                                <React.Fragment key={index}>
                                    <tr>
                                        <td className="text-muted">Subtotal {tax.rate}%:</td>
                                        <td className="text-end fw-medium">{formatDecimal(tax.base)}</td>
                                    </tr>
                                    {tax.rate > 0 && (
                                        <tr>
                                            <td className="text-muted">el IVA {tax.rate}%:</td>
                                            <td className="text-end fw-medium">{formatDecimal(tax.tax)}</td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))}

                            <tr>
                                <td className="d-flex align-items-center text-muted">
                                    Propina:
                                    <div className="form-check form-switch ms-2">
                                    </div>
                                </td>
                                <td className="text-end">
                                    <Input
                                        type="number"
                                        value={formik.values.tip}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            formik.setFieldValue("tip", val === '' ? 0 : parseFloat(val));
                                        }}
                                        name="tip"
                                        className="form-control form-control-sm text-end d-inline-block"
                                        style={{ width: '80px' }}
                                    />
                                </td>
                            </tr>
                            <tr className="border-top border-dark">
                                <td className="fs-5 fw-bold text-dark pt-3">Total a Pagar:</td>
                                <td className="fs-5 fw-bold text-primary text-end pt-3">${formatDecimal(safeCalculateTotal())}</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
            </CardBody>
        </Card>
    );
};

export default TotalsSummary;
